const scale = 10;
const headSize = scale * 3;

export interface HeadRenderingParameters {
  scale: number;
  headSize: number;
  circleSize: number;
  hoverColourScalar: number;
}

export const headNodeParameters: HeadRenderingParameters = {
  scale,
  headSize,
  circleSize: headSize * 0.25,
  hoverColourScalar: 0.8,
};

export const linkRenderingParameters = {
  linkStopDistance: headSize * 2,
};

export const leaderTypesForHead = [
  { leaderType: "Innovator", x: 0, y: 2, colour: "#6DC8BF" },
  { leaderType: "Entrepreneurial", x: -1, y: 1, colour: "#F8C31C" },
  { leaderType: "Executional", x: -2, y: 0, colour: "#F3A123" },
  { leaderType: "Practical", x: -1, y: -1, colour: "#C0C0C0" },
  { leaderType: "Strategist", x: 0, y: -2, colour: "#823CBE" },
  { leaderType: "Servant", x: 1, y: -1, colour: "#BF1224" },
  { leaderType: "Transformational", x: 2, y: 0, colour: "#ED0B6F" },
  { leaderType: "Charismatic", x: 1, y: 1, colour: "#B0BB36" },
  { leaderType: "Professional", x: 0, y: 0, colour: "#67A6DC" },
];
